import { Configuration } from './model';
import { useUIConfigurationContext } from './uiConfigurationContext';

export const useUIConfiguration = <
  K extends keyof Configuration,
  P extends keyof Configuration[K],
>(
  component: K,
  property: P,
): Configuration[K][P] => {
  const configuration = useUIConfigurationContext();

  return configuration[component][property];
};
